import Vue from 'vue'
import { store as $store } from '@/store'
import { $case } from '@/filters'

export const getIntroducingUserIdFromLocalStorage = chat => {
    const storedIntroducingUsers = window.localStorage.getItem('introducingUsers')
    if (!storedIntroducingUsers) return

    const users = JSON.parse(storedIntroducingUsers)
    if (!users || users.length === 0) return

    const introducingUserId = (users.find(p => p.c === chat.id) || {}).i
    return introducingUserId
}

export const updateSortInLocalStorage = chats => {
    const $$sortToStore = JSON.stringify(
        chats
            .filter(c => c.$$sort)
            .map(c => ({
                c: c.id,
                s: c.$$sort,
            }))
    )
    window.localStorage.setItem('sort', $$sortToStore)
}

export const updateFiltersInLocalStorage = chats => {
    const $$filtersToStore = JSON.stringify(
        chats
            .filter(c => c.$$filters)
            .map(c => ({
                c: c.id,
                f: c.$$filters,
            }))
    )

    const setFilters = async () => {
        try {
            await window.localStorage.setItem('filters', $$filtersToStore)
        } catch (e) {
            // If $$filtersToStore is too big, this happens.
        }
    }
    setFilters()
}

export const updateIntroducingUsersInLocalStorage = chats => {
    let users = []
    const stored = window.localStorage.getItem('introducingUsers')
    if (stored) {
        users = JSON.parse(stored)
    }

    chats
        .filter(c => c.$$introducingUser)
        .forEach(c => {
            const found = users.find(u => u.c === c.id)
            if (found) {
                found.i = c.$$introducingUser.id
            } else {
                users.push({
                    c: c.id,
                    i: c.$$introducingUser.id,
                })
            }
        })

    window.localStorage.setItem('introducingUsers', JSON.stringify(users))
}

export const removeIntroducingUserInLocalStorage = chat => {
    let users = []
    const stored = window.localStorage.getItem('introducingUsers')
    if (stored) {
        users = JSON.parse(stored)
    }

    const toRemove = users.map(p => p.c).indexOf(chat.id)
    users.splice(toRemove, 1)
    window.localStorage.setItem('introducingUsers', JSON.stringify(users))
}

export const updatePremiumAcceptedUsersInLocalStorage = chats => {
    let users = []
    const stored = window.localStorage.getItem('premiumAcceptedUsers')
    if (stored) {
        users = JSON.parse(stored)
    }

    chats
        .filter(c => c.$$premiumAcceptedUser)
        .forEach(c => {
            const found = users.find(u => u.c === c.id)
            if (found) {
                found.i = c.$$premiumAcceptedUser.id
            } else {
                users.push({
                    c: c.id,
                    i: c.$$premiumAcceptedUser.id,
                })
            }
        })

    window.localStorage.setItem('premiumAcceptedUsers', JSON.stringify(users))
}

export const removePremiumAcceptedUserInLocalStorage = chat => {
    let users = []
    const stored = window.localStorage.getItem('premiumAcceptedUsers')
    if (stored) {
        users = JSON.parse(stored)
    }

    const toRemove = users.map(p => p.c).indexOf(chat.id)
    users.splice(toRemove, 1)
    window.localStorage.setItem('premiumAcceptedUsers', JSON.stringify(users))
}

export const loadStoredSort = chats => {
    let sort
    const storedSort = window.localStorage.getItem('sort')
    if (storedSort) {
        sort = JSON.parse(storedSort)
    }
    if (!sort || sort.length === 0) return
    ;(chats || []).forEach(c => {
        const found = sort.find(s => s.c === c.id)
        if (found) {
            c.$$sort = found.s
        }
    })
}

export const loadStoredFilters = chats => {
    const isFiltersLatestVersion = (filters, chat) => {
        // chat.user 안에 $$premium 이 있는데도 chat.user.$$premium == undefined가 뜬다 왜지.
        const defaultFilters = getDefaultFilters(chat.user.gender, chat.user.$$premium ? true : false)

        if (Object.keys(defaultFilters).length !== Object.keys(filters).length) return false

        if (Object.keys(defaultFilters).some(key => filters[key] === undefined)) return false

        if (
            Object.keys(defaultFilters).some(
                key =>
                    (Array.isArray(defaultFilters[key]) && !Array.isArray(filters[key])) ||
                    (!Array.isArray(defaultFilters[key]) && Array.isArray(filters[key])) ||
                    (Array.isArray(defaultFilters[key]) &&
                        Array.isArray(filters[key]) &&
                        defaultFilters[key].length !== filters[key].length)
            )
        ) {
            return false
        }

        return Object.keys(defaultFilters)
            .filter(key => Array.isArray(defaultFilters[key]))
            .every(key => defaultFilters[key].length === filters[key].length)
    }

    let filters
    const storedFilters = window.localStorage.getItem('filters')
    if (storedFilters) {
        filters = JSON.parse(storedFilters)
    }
    if (!filters || filters.length === 0) return
    ;(chats || []).forEach(c => {
        const found = (filters || []).find(f => f.c === c.id)
        if (found && isFiltersLatestVersion(found.f, c)) {
            Vue.set(c, '$$filters', found.f)
        }
    })
    updateFiltersInLocalStorage(chats)
}

export const canSkipApiCall = (state, data) => {
    if (!state.lastApiCall) {
        Vue.set(state, 'lastApiCall', {})
    }

    const initLastApiCallTime = () => Vue.set(state.lastApiCall, data, Vue.prototype.$moment())
    // If it's never called, can't skip API call.
    if (!state.lastApiCall[data]) {
        initLastApiCallTime()
        return false
    }

    const diff = Vue.prototype.$moment().diff(state.lastApiCall[data], 'seconds')
    if (diff <= 60 * 30) {
        return true
    }
    initLastApiCallTime()
    return false
}

export const setAgeHeightFiltersByStyles = (chat, filters) => {
    if (!chat || !filters) return

    const style = chat.user.style || {}
    // let minHeight = 140
    // let maxHeight = 199
    if (Object.keys(style).length === 0) return

    // if (chat.user.gender === 0) {
    //     if (style.height_type === 1) {
    //         minHeight = 163
    //     } else if (style.height_type === 2) {
    //         maxHeight = 162
    //     }
    // } else {
    //     if (style.height_type === 1) {
    //         minHeight = chat.user.profile.height
    //     } else if (style.height_type === 2) {
    //         minHeight = 172
    //     } else if (style.height_type === 3) {
    //         minHeight = 175
    //     }
    // }

    Vue.set(filters, 'minHeight', style.min_height)
    Vue.set(filters, 'maxHeight', style.max_height)
    Vue.set(filters, 'minAge', style.min_age)
    Vue.set(filters, 'maxAge', style.max_age)
    const smoking = filters.smoking
    //   const marry_type = filters.marryType;

    if (style.smoking_type === 0) {
        smoking[0].selected = true
        smoking[1].selected = true
    }
    if (style.smoking_type === 1) {
        smoking[0].selected = false
        smoking[1].selected = true
    }
    if (style.smoking_type === 2) {
        smoking[0].selected = true
        smoking[1].selected = false
    }

    // 기본 필터 여기 고쳐주면됨
    //   if (style.marry_type === 1) {
    //     marry_type[1].selected = true;
    //     marry_type[2].selected = false;
    //     marry_type[3].selected = false;
    //   }
    //   if (style.marry_type === 2) {
    //     marry_type[1].selected = false;
    //     marry_type[2].selected = true;
    //     marry_type[3].selected = false;
    //   }
    //   if (style.marry_type === 3) {
    //     marry_type[1].selected = true;
    //     marry_type[2].selected = true;
    //     marry_type[3].selected = true;
    //   }

    // Vue.set(filters, 'smoking', smoking)
}

export const getVisitFilters = () => window.localStorage.getItem('visitFilter')

export const setVisitFilters = () => window.localStorage.setItem('visitFilter', true)

export const getStoredDefaultFilters = () => window.localStorage.getItem('defaultFilter')

export const getSettingDefaultFilters = (fromSetting, isPremium) => {
    const storedFilter = getStoredDefaultFilters()
    const defaultFilter = {
        basic: [
            {
                name: '선호이성상',
                value: 'preferences',
                selected: !fromSetting,
            },
            {
                name: '이미 소개 X',
                value: 'neverIntroduced',
                selected: !fromSetting,
            },
            {
                name: '20km 이내',
                value: 'closeUser',
                selected: false,
            },
        ],
        lastSign: isPremium
            ? [
                  {
                      name: '전체',
                      value: 0,
                      selected: true,
                  },
                  {
                      name: '1일 이내',
                      value: 1,
                      selected: false,
                  },
                  {
                      name: '2일 이내',
                      value: 2,
                      selected: false,
                  },
                  {
                      name: '7일 이내',
                      value: 7,
                      selected: false,
                  },
                  {
                      name: '7일 초과',
                      value: -7,
                      selected: false,
                  },
              ]
            : [
                  {
                      name: '전체',
                      value: 0,
                      selected: true,
                  },
                  {
                      name: '1일 이내',
                      value: 1,
                      selected: false,
                  },
                  {
                      name: '2일 이내',
                      value: 2,
                      selected: false,
                  },
                  {
                      name: '7일 이내',
                      value: 7,
                      selected: false,
                  },
              ],
    }
    const isFiltersLatestVersion = (storedFilter, defaultFilter) => {
        if (Object.keys(storedFilter).length !== Object.keys(defaultFilter).length) return false

        if (Object.keys(storedFilter).some(key => defaultFilter[key] === undefined)) return false

        if (
            Object.keys(storedFilter).some(
                key =>
                    (Array.isArray(storedFilter[key]) && !Array.isArray(defaultFilter[key])) ||
                    (!Array.isArray(storedFilter[key]) && Array.isArray(defaultFilter[key])) ||
                    (Array.isArray(storedFilter[key]) &&
                        Array.isArray(defaultFilter[key]) &&
                        storedFilter[key].length !== defaultFilter[key].length)
            )
        ) {
            return false
        }

        return Object.keys(storedFilter)
            .filter(key => Array.isArray(storedFilter[key]))
            .every(key => storedFilter[key].length === defaultFilter[key].length)
    }
    if (storedFilter) {
        const storedFilterJson = JSON.parse(storedFilter)
        if (!isFiltersLatestVersion(storedFilterJson, defaultFilter)) return defaultFilter
        return storedFilterJson
    } else return defaultFilter
}

export const getDefaultFilters = (genderOfCurrentChat, isPremium) =>
    Object.assign(getSettingDefaultFilters(false, isPremium), {
        minAge: 20,
        maxAge: 100,
        minHeight: 140,
        maxHeight: 199,
        distance: 35,
        searchByDistance: true,
        nickname: '',
        preferences: [
            {
                name: 'on',
                value: true,
                selected: true,
            },
            {
                name: 'off',
                value: false,
                selected: false,
            },
        ],
        no_ons_campaign: [
            {
                name: '전체',
                value: null,
                selected: true,
            },
            {
                name: '참여중',
                value: 1,
                selected: false,
            },
        ],
        neverIntroduced: [
            {
                name: '님에게 이미 소개한 상대',
                value: 'send',
                selected: true,
            },
        ],
        appearanceRate: [
            {
                name: '최상',
                value: [9, 10],
                selected: true,
            },
            {
                name: '상',
                value: [7, 8],
                selected: true,
            },
            {
                name: '중',
                value: [4, 5, 6],
                selected: true,
            },
            {
                name: '하',
                value: [1, 2, 3],
                selected: true,
            },
            {
                name: '신규',
                value: [-1, 0],
                selected: true,
            },
        ],
        interest: [
            {
                name: 'on',
                value: true,
                selected: false,
            },
            {
                name: 'off',
                value: false,
                selected: true,
            },
        ],
        targetHeightType:
            genderOfCurrentChat === 0
                ? [
                      { name: '안 봄', value: [0], selected: true },
                      { name: '나보다 큰', value: [1], selected: true },
                      { name: '평균', value: [2], selected: true },
                      { name: '큰 키', value: [3], selected: true },
                  ]
                : [
                      { name: '안 봄', value: [0], selected: true },
                      { name: '작은 키', value: [2], selected: true },
                      { name: '큰 키', value: [1], selected: true },
                  ],
        minTargetHeight: 140,
        maxTargetHeight: 199,
        targetFriendType: [
            {
                name: '안 봄',
                value: [0],
                selected: true,
            },
            {
                name: '평균 이상',
                value: [1],
                selected: true,
            },
            {
                name: '눈 높음',
                value: [2],
                selected: true,
            },
        ],
        targetSpecType: [
            {
                name: '안 봄',
                value: [0],
                selected: true,
            },
            {
                name: '비슷한',
                value: [1, 2],
                selected: true,
            },
            {
                name: '더 좋은',
                value: [3],
                selected: true,
            },
        ],
        targetSmokingType: [
            {
                name: '상관 없음',
                value: [0],
                selected: true,
            },
            {
                name: '비흡연자 선호',
                value: [1],
                selected: true,
            },
            {
                name: '흡연자 선호',
                value: [2],
                selected: true,
            },
        ],
        smoking: [
            {
                name: '흡연',
                value: true,
                selected: true,
            },
            {
                name: '비흡연',
                value: false,
                selected: true,
            },
        ],
        car: [
            {
                name: '보유',
                value: true,
                selected: true,
            },
            {
                name: '미보유',
                value: false,
                selected: true,
            },
        ],
        pet: [
            {
                name: '키움',
                value: true,
                selected: true,
            },
            {
                name: '키우지 않음',
                value: false,
                selected: true,
            },
        ],
        isStudent: [
            {
                name: '대학생',
                value: true,
                selected: true,
            },
            {
                name: '일반인(직장인)',
                value: false,
                selected: true,
            },
        ],
        religion: $store.getters.religions.map(r => ({
            name: r.name,
            value: r.id,
            selected: true,
        })),
        marryType: [
            {
                name: '초혼만 원함',
                value: [0],
                selected: true,
            },
            {
                name: '재혼만 원함',
                value: [1],
                selected: true,
            },
            {
                name: '둘다 관계없음',
                value: null,
                selected: true,
            },
        ],
        childType: [
            {
                name: '자녀가 없는 분만 원함',
                value: [0],
                selected: true,
            },
            {
                name: '자녀가 있는 분만 원함',
                value: [1],
                selected: true,
            },
            {
                name: '둘다 상관없음',
                value: null,
                selected: true,
            },
        ],
        regionType: [
            {
                name: '수도권',
                value: [0],
                selected: true,
            },
            {
                name: '영남권(경상도)',
                value: [1],
                selected: true,
            },
            {
                name: '호남권(전라도)',
                value: [2],
                selected: true,
            },
            {
                name: '충청권',
                value: [3],
                selected: true,
            },
            {
                name: '강원권',
                value: [4],
                selected: true,
            },
            {
                name: '제주',
                value: [5],
                selected: true,
            },
        ],
        carType: $store.getters.carTypes.map(r => ({
            name: r.name,
            value: r.id,
            selected: true,
        })),
        incomeType: $store.getters.incomeTypes.map(r => ({
            name: r.name,
            value: r.id,
            selected: true,
        })),
        assetType: $store.getters.assetTypes.map(r => ({
            name: r.name,
            value: r.id,
            selected: true,
        })),
        exercise: $store.getters.exercises.map(r => ({
            name: r.name,
            value: r.id,
            selected: true,
        })),
        houseStyle: $store.getters.houseStyles.map(r => ({
            name: r.name,
            value: r.id,
            selected: true,
        })),
        housePayment: $store.getters.housePayments.map(r => ({
            name: r.name,
            value: r.id,
            selected: true,
        })),
        kind: $store.getters.kinds
            .filter(k => k.gender !== genderOfCurrentChat)
            .map(p => ({
                name: p.name,
                value: p.id,
                selected: true,
            })),
        shape: $store.getters.shapes
            .filter(s => s.gender !== genderOfCurrentChat)
            .map(p => ({
                name: p.name,
                value: p.id,
                selected: true,
            })),
        mbti: $store.getters.mbti.map(p => ({
            name: p.name,
            value: p.id,
            selected: true,
        })),
        jobCategory: $store.getters.jobCategories.map(j => ({
            name: j.name,
            value: j.id,
            selected: true,
        })),
        school: $store.getters.schools.map(s => ({
            name: s.name,
            value: s.id,
            selected: true,
        })),
        schoolType: [
            ...$store.getters.schoolTypes.map(s => ({
                name: s.name,
                value: s.id,
                selected: true,
            })),
            {
                name: '명문대', // constants 에는 없지만, 기획적으로 추가된 필터.
                value: 17,
                selected: true,
            },
        ],
        province: $store.getters.provinces.map(p => ({
            name: p.name,
            value: p.id,
            selected: true,
        })),
    })

// 만약 맨 위로 올려져야 하는 채팅방이 현재 필터의 조건에 부합하지 않으면 무시 (위로 끌올 X)
export const shouldThisChatBeIgnored = (chat, chatFilters) => {
    if (chatFilters.lastSign.selected && chat.user.status !== 0) return true

    if (chatFilters.type === 'MALE' && chat.user.gender === 1) return true

    if (chatFilters.type === 'FEMALE' && chat.user.gender === 0) return true

    if (chatFilters.friends.selected && !chatFilters.dDayFriends.selected && !chat.expire_at) return true

    if (!chatFilters.friends.selected && chatFilters.dDayFriends.selected && chat.expire_at) return true

    if (chatFilters.hasTicket.selected && !chat.user.hasTickets) return true

    // if (chatFilters.premium.selected && !chat.user.$$premium) return true

    return false
}

export const chatFiltersToServerFilterPayload = ({ chatSearchValue, chatFilters, lastChat, limit }) => {
    const params = { limit: limit || 10 }
    if (chatSearchValue) {
        params.query = chatSearchValue
    }

    if (lastChat) params.last_updated_at = lastChat.last_message.updated_at
    if (chatFilters.type === 'MALE') params.gender = 0
    if (chatFilters.type === 'FEMALE') params.gender = 1
    if (chatFilters.lastSign.selected) params.last_sign = 2
    if (chatFilters.notToday.selected) params.not_today = true
    if (chatFilters.lastWeek.selected) params.last_sign = 7
    if (chatFilters.friends.selected && !chatFilters.dDayFriends.selected) params.type = 'normal'
    if (chatFilters.dDayFriends.selected && !chatFilters.friends.selected) params.type = 'instant'
    if (chatFilters.hasTicket.selected) params.has_ticket = true
    if (chatFilters.isPremium.selected) params.is_premium = true
    if (chatFilters.harvest.selected) params.harvest = true
    if (chatFilters.bothLike.selected) params.both_like = true
    if (chatFilters.waitDating.selected) params.wait_dating = true
    if (chatFilters.bookmark.selected) params.bookmark = true

    if (chatFilters.type === 'SEARCH_DETAIL') {
        if (chatFilters.detail.matchCount.value !== 0) {
            params.match_count = chatFilters.detail.matchCount.value
        }

        ;['photoCount', 'agentCount', 'refundRate', 'payRate'].forEach(key => {
            if (chatFilters.detail[key].value !== 0) {
                params[$case.toSnake(key)] = chatFilters.detail[key].value
            }
        })
    }

    return params
}

export const filtersToSuperSearchPayload = filters => {
    console.log('783 : ', filters)
    const params = {
        min_age: filters.minAge,
        max_age: filters.maxAge,
        min_height: filters.minHeight,
        max_height: filters.maxHeight,
        min_target_height: filters.minTargetHeight,
        max_target_height: filters.maxTargetHeight,
    }

    if (filters.searchByDistance) {
        params.distance = filters.distance
    } else {
        params.province_ids = filters.province.filter(item => item.selected).map(item => item.value)
    }
    params.nickname = filters.nickname

    if (filters.marryType.some(filter => !filter.selected)) {
        params.marry_type = filters.marryType
            .filter(filter => filter.selected)
            .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    }
    if (filters.childType.some(filter => !filter.selected)) {
        params.child_type = filters.childType
            .filter(filter => filter.selected)
            .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    }
    if (filters.assetType.some(filter => !filter.selected)) {
        params.asset_type = filters.assetType
            .filter(filter => filter.selected)
            .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    }
    if (filters.incomeType.some(filter => !filter.selected)) {
        params.income_type = filters.incomeType
            .filter(filter => filter.selected)
            .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    }

    params.never_introduced = filters.neverIntroduced
        .filter(filter => filter.selected)
        .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])

    // Multiselect O
    if (filters.appearanceRate.some(filter => !filter.selected)) {
        params.appearance_rate = filters.appearanceRate
            .filter(filter => filter.selected)
            .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    }
    if (filters.shape.some(filter => !filter.selected)) {
        params.shape = filters.shape
            .filter(filter => filter.selected)
            .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    }
    if (filters.kind.some(filter => !filter.selected)) {
        params.kind = filters.kind
            .filter(filter => filter.selected)
            .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    }
    if (filters.mbti.some(filter => !filter.selected)) {
        params.mbti = filters.mbti
            .filter(filter => filter.selected)
            .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    }
    if (filters.religion.some(filter => !filter.selected)) {
        params.religion_ids = filters.religion
            .filter(filter => filter.selected)
            .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    }

    // const types = ['heightType', 'friendType', 'specType', 'smokingType', 'incomeType', 'regionType', 'assetType', 'carType', 'marryType', 'childType']
    // types.forEach(key => {
    //     if (filters[`target${$case.toCapital(key)}`].some(filter => !filter.selected)) {
    //         params[$case.toSnake(key)] = filters[`target${$case.toCapital(key)}`]
    //             .filter(filter => filter.selected)
    //             .reduce((result, curObj) => (result || []).concat(curObj.value || []), [])
    //     }
    // })

    // Multiselect X
    const noMultiSelect = ['lastSign', 'interest', 'smoking', 'isStudent', 'car', 'pet', 'no_ons_campaign']
    noMultiSelect.forEach(key => {
        if (filters[key].filter(filter => filter.selected).length === 1) {
            params[Vue.options.filters.$case.toSnake(key)] = filters[key].find(filter => filter.selected).value
        }
    })

    const detailFilterPairs = {
        jobCategory: 'job_category_ids',
        schoolType: 'school_type_ids',
    }

    Object.keys(detailFilterPairs).forEach(key => {
        const selectedValues = (filters[key] || []).filter(item => item.selected).map(item => item.value)

        if (selectedValues.length === (filters[key] || []).length) return

        params[detailFilterPairs[key]] = selectedValues
    })
    return params
}

export const setDefaultFiltersOnChat = chat => {
    const defaultFilters = getDefaultFilters(chat.user.gender, chat.user.$$premium ? true : false)
    Vue.set(chat, '$$filters', defaultFilters)
    setAgeHeightFiltersByStyles(chat, chat.$$filters)
}

export const applyingFilters = filters => {
    if (!filters) return

    const curChatUser = $store.getters.chat.user || {}
    const defaultFilters = getDefaultFilters(curChatUser.gender, curChatUser.$$premium ? true : false)
    const sliderKeys = ['minAge', 'maxAge', 'minHeight', 'maxHeight']
    if (sliderKeys.some(key => defaultFilters[key] !== filters[key])) {
        return true
    }

    return Object.keys(defaultFilters).some(key => {
        // Don't check sliderKeys here because it's already checked above
        if (sliderKeys.indexOf(key) !== -1) return

        if (JSON.stringify(defaultFilters[key]) !== JSON.stringify(filters[key])) {
            return true
        }
    })
}
